import {createSlice} from "@reduxjs/toolkit";
import {suppliersCategoryData} from "../../../_data/suppliers/suppliers-settings";
import moment from "moment";
import {getCurrentUser} from "../../../_helpers/commonFunctions";

const currentDate = moment().format('DD/MM/YYYY');
const currentTime = moment().format('H:mm');
const currentUser = getCurrentUser();
const cUserName = currentUser?.name;
let date = new Date();
const currentMonth = moment().format("MM");
const current = new Date();
const lastDayOfYear = (localStorage.getItem("company") && JSON.parse(localStorage.getItem("company"))?.year !== moment().format("YYYY")) ? moment().year(JSON.parse(localStorage.getItem("company"))?.year).endOf('year').format('DD-MM-YYYY') : null;
const newInstallationInitialValue = {
    no: 1,
    type: '',
    address: '',
    DOY: '',
    city: '',
    id: 1,
    vatCategory: '',
    vatReason: '',
    customVat: ''
}

const newSupplierInitialValue = {
    category: "",
    categoryName: "",
    systemCode: "",
    manualCode: "",
    name: "",
    smallName: "",
    vatCategory: "Normal VAT",
    vatReason: "",
    customVat: "",
    vatNumber: "",
    DOY: "",
    activity: "",
    amka: "",
    country: "",
    address: "",
    city: "",
    postalCode: "",
    email: "",
    gemhNo: "",
    webpage: "",
    phone: "",
    contactPoints: [{
        no: 1,
        id: 1,
        name: "",
        mobile: "",
        landline: "",
        otherPhone: "",
        email: "",
        contactNotes: ""
    }],
    bankInfo: [],
    supplierNotes: "",
    informationNotes: "",
    notesNotes: "",
    installations: [newInstallationInitialValue],
    communicationHistory: [],
    information: [],
    notes: {},
    emron: "",
    accounting: "",
    bypassAccounting: "",
    suppliersInfo: [],
    isActive: 'active',
    balance: 0,
}

export const supplierSettingsInitialValues = {
    categories: suppliersCategoryData,
    googleCalendarApi: "",
    supplierCommunicationHistory: "",
    suppliersInfo: [],
    type: "suppliersSettings",
    isActive: "active"
}

const supplierMovementsInitialValues = {
    documentType: '',
    documentTypeName: '',
    document_file: '',
    number: '',
    date: date,
    reason: '',
    sum: 0,
    suppliers: [],
    notes: '',
}

const priceListInitialValues = {
    name: "",
    price: "",
    supplierList: [],
    notes: "",
}

const newContactPointInitialValue = {
    no: 1,
    id: 1,
    name: "",
    mobile: "",
    landline: "",
    otherPhone: "",
    email: "",
    // acceptsNotifications: false,
    contactNotes: ""
}

const newBankInfoInitialValue = {
    bankFriendlyName: "",
    bankInstitute: "",
    iban: ""
}

const newInformationInitialValue = {
    no: 1,
    description: '',
    details: '',
    date: currentDate.toString(),
    time: currentTime.toString(),
    lastEditedBy: cUserName,
}

const supplierMovementsNewSupplierInitialValue = {
    no: 1,
    supplierId: "",
    name: "",
    code: "",
    measurementUnit: "",
    quantity: 0,
}

const newCommunicationHistoryInitialValue = {
    no: 1,
    id: 1,
    date: new Date(),
    time: currentTime.toString(),
    subject: "",
    details: "",
    followUpDate: "",
    createCalenderEvent: false,
    done: false
}

export const newSupplierPaymentInitialValue = {
    documentType: "",
    documentTypeName: "",
    installation: "",
    preNumber: "",
    number: "",
    numberingMode: "manual",
    date: null,
    paymentType: "",
    paymentTypeName: "",
    supplier: "",
    supplierName: "",
    vatNumber: "",
    address: "",
    country: "",
    phone: "",
    email: "",
    reason: "",
    paymentNotes: "",
    amount: "0",
    posDetails: [{
        no: 1,
        id: 1,
        name: "",
        registrationNumber: "",
        amount: "0",
        notes: ""
    }],
    bankDetails: [{
        no: 1,
        id: 1,
        name: "",
        accountNumber: "",
        amount: "0",
        notes: ""
    }],
    chequeDetails: [{
        no: 1,
        id: 1,
        name: "",
        registrationNumber: "",
        amount: "0",
        notes: ""
    }],
}


const newSupplierEmronPasswordInitialValue = {
    no: 1,
    id: 1,
    pid: "",
    type: "",
    typeName: "",
    username: "",
    password: "",
    notes: "",
    isActive: 'active',
}

const newSupplierEmronStockholderInitialValue = {
    no: 1,
    id: 1,
    name: "",
    surname: "",
    vat: "",
    position: "",
    percentage: "",
    stockValue: 0,
    dateFrom: "",
    dateTo: "",
    isActive: 'active',
}

const newCategoryInitialValue = {
    _id: 1,
    category: '',
    mask: 'CCM-0001',
    maskCode: '',
    maskCodePrefix: 'CCM',
    maskCodeCounter: 1,
    isActive: 'active',
    type: 'supplier',
}

const initSupplierBalanceReportRequestData = {
    page: 1,
    date_to: lastDayOfYear ? lastDayOfYear : moment().format("DD/MM/YYYY"),
    supplier: "",
    includeInactive: false,
    includeZeroBalance: false,
}

const initSupplierBalanceReportResponseData = {
    data: [],
    totalPages: 0,
    totalBalance: 0,
}

const initSupplierMovementsReportRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    supplierIds: [],
    supplier_zero: "inactive",
    supplier_inactive: "inactive",
    showNotes: "inactive",
}

const initSupplierMovementsReportResponseData = {
    totalPages: 0,
    pageData: [],
    pageSupplierData: {},
}

const initSupplierIsozygioReportRequestData = {
    firstLoad: true, // For date setup
    zeroBalanceSuppliers: false,
    page: 1,
    date_from: "",
    date_to: "",
    supplierName: "",
    supplierId: "",
}

const initSupplierIsozygioReportResponseData = {
    totalPages: 0,
    data: [],
}

const initSupplierIsozygioReportTotals = [];

const initialState = {
    supplierSettingsInitialValues: supplierSettingsInitialValues,
    newSuppliersSettings: supplierSettingsInitialValues,
    suppliersSettings: supplierSettingsInitialValues,
    suppliersListData: [],
    suppliersPayment: [],
    supplierPayments: [],
    newSupplierPaymentInitialValue: newSupplierPaymentInitialValue,
    newSupplierPayment: newSupplierPaymentInitialValue,
    autoSupplierPaymentData: null,
    editSupplierPayment: newSupplierPaymentInitialValue,
    loading: false,
    hasErrors: false,
    suppliers: [],
    installations: [],
    supplierPaymentsTemplates: [],
    newSupplierInitialValue: newSupplierInitialValue,
    newSupplierModal: newSupplierInitialValue,
    newSupplier: newSupplierInitialValue,
    editSupplier: {},
    newContactPointInitialValue: newContactPointInitialValue,
    newContactPoint: newContactPointInitialValue,
    editContactPoint: newContactPointInitialValue,
    newBankInfoInitialValue: newBankInfoInitialValue,
    editBankInfo: newBankInfoInitialValue,
    newBankInfo: newBankInfoInitialValue,
    newInstallationInitialValue: newInstallationInitialValue,
    newInstallation: newInstallationInitialValue,
    newInformationInitialValue: newInformationInitialValue,
    newInformation: newInformationInitialValue,
    newNotesInitialValue: newInformationInitialValue,
    newNotes: {},
    newCommunicationHistoryInitialValue: newCommunicationHistoryInitialValue,
    newCommunicationHistory: newCommunicationHistoryInitialValue,
    searchSuppliers: [],
    totalItemsSSS: 0,
    perPageSSS: 0,
    searchSupplierMovements: [],
    supplierReportBalanceData: [],
    supplierMovementsClientList: [],
    totalItemsSMS: 0,
    perPageSMS: 0,
    totalItemsSMSS: 0,
    perPageSMSS: 0,
    searchSupplierPayments: [],
    perPageSPS: 0,
    totalItemsSPS: 0,
    selectedStartDateFrom: null,
    selectedStartDateTo: null,
    selectedDateBalance: current,
    selectedZero: false,
    selectedInactive: false,
    selectedZeroBalance: false,
    selectedInactiveBalance: false,
    selectedFilterBy: currentMonth,
    searchSuppliersMovementsReport: [],
    searchCommunicationHistory: [],
    selectedSupplierFrom: {},
    supplierMovementsSearchByBalance: {},
    selectedSupplierTo: {},
    selectedBalanceSupplierFrom: {},
    selectedBalanceSupplierTo: {},
    selectedSalesSupplierFrom: {},
    selectedSalesSupplierTo: {},
    selectedSalesBalanceSupplierFrom: {},
    selectedSalesBalanceSupplierTo: {},
    selectedSalesGraphicSupplierFrom: {},
    selectedSalesGraphicSupplierTo: {},
    selectedBuysSupplierFrom: {},
    selectedBuysSupplierTo: {},
    selectedBuysBalanceSupplierFrom: {},
    selectedBuysBalanceSupplierTo: {},
    selectedBuysGraphicSupplierFrom: {},
    selectedBuysGraphicSupplierTo: {},
    selectedSupplierMovement: {},
    supplierTemplates: [],
    selectedSupplierTemplate: {},
    supplierMovements: [],
    supplierMovementsTemplates: [],
    selectedSupplierMovementsTemplate: {},
    supplierMovementsNewSupplierInitialValue: supplierMovementsNewSupplierInitialValue,
    supplierMovementsNewSupplier: supplierMovementsNewSupplierInitialValue,
    supplierPriceListTemplates: [],
    selectedSupplierPriceListTemplate: {},
    supplierMovementReportData: [],
    submitting: false,
    selectedCategoryData: {},
    supplierMovementsInitialValues: supplierMovementsInitialValues,
    supplierMovementsSuppliers: [],
    newSupplierMovements: supplierMovementsInitialValues,
    editSupplierMovements: {},
    priceListInitialValues: priceListInitialValues,
    priceListSuppliers: [],
    newPriceList: priceListInitialValues,
    newQuickSupplier: newSupplierInitialValue,
    supplierEmron: {
        password: [],
        capital: '',
        stockholders: [],
        supplierId: '',
    },
    newSupplierEmronPasswordInitialValue: newSupplierEmronPasswordInitialValue,
    newSupplierEmronPassword: newSupplierEmronPasswordInitialValue,
    editSupplierEmronPassword: newSupplierEmronPasswordInitialValue,
    newSupplierEmronStockholderInitialValue: newSupplierEmronStockholderInitialValue,
    newSupplierEmronStockholder: newSupplierEmronStockholderInitialValue,
    editSupplierEmronStockholder: newSupplierEmronStockholderInitialValue,
    selectedSupplierPaymentsTemplate: {},
    newCategoryInitialValue: newCategoryInitialValue,
    newCategory: newCategoryInitialValue,
    categories: suppliersCategoryData,

    // Supplier Balance Report
    reportSupplierBalanceRequestData: {},
    reportSupplierBalanceResponseData: {},

    // Supplier Movements Report
    supplierMovementsReportRequestData: {},
    supplierMovementsReportResponseData: {},

    // Supplier Isozygio Report
    supplierIsozygioReportRequestData: {},
    supplierIsozygioReportResponseData: {},
    supplierIsozygioReportTotals: {},

    selectedSupplierCategory: {}
}

// Supplier Slice
export const SuppliersSlice = createSlice({
    name: "supplier",
    initialState,
    reducers: {
        setSupplierNewCategory: (state, {payload}) => {
            state.newCategory = payload;
        },

        resetSupplierNewCategory: (state) => {
            state.newCategory = state.newCategoryInitialValue;
        },

        setSupplierPaymentsTemplates: (state, {payload}) => {
            state.supplierPaymentsTemplates = payload;
        },

        setSuppliers: (state, {payload}) => {
            state.suppliers = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setNewSupplier: (state, {payload}) => {
            state.newSupplier = payload;
        },

        resetNewSupplier: (state) => {
            state.newSupplier = state.newSupplierInitialValue;
        },

        setNewSupplierModal: (state, {payload}) => {
            state.newSupplierModal = payload;
        },

        resetNewSupplierModal: (state) => {
            state.newSupplierModal = state.newSupplierInitialValue;
        },

        setNewSupplierStatus: (state, {payload}) => {
            state.newSupplier.isActive = payload;
        },

        setEditSupplier: (state, action) => {
            const tabKey = action?.meta?.tabKey;
            if (!tabKey) { // Update by open _id
                for (const key in state.editSupplier) {
                    if (state.editSupplier[key]._id === action.payload._id) {
                        state.editSupplier[key] = action.payload;
                        break;
                    }
                }
            } else {
                state.editSupplier[tabKey] = action.payload;
            }
        },

        setEditSupplierStatus: (state, {payload}) => {
            state.editSupplier.isActive = payload;
        },

        setNewContactPoint: (state, {payload}) => {
            state.newContactPoint = payload;
        },

        setEditContactPoint: (state, {payload}) => {
            state.editContactPoint = payload;
        },

        setNewBankInfo: (state, {payload}) => {
            state.newBankInfo = payload;
        },

        setEditBankInfo: (state, {payload}) => {
            state.editBankInfo = payload;
        },

        resetNewBankInfo: (state) => {
            state.newBankInfo = state.newBankInfoInitialValue;
        },

        resetEditBankInfo: (state) => {
            state.editBankInfo = state.newBankInfoInitialValue;
        },

        setNewInstallations: (state, {payload}) => {
            state.newInstallation = payload;
        },

        resetNewInstallations: (state) => {
            state.newInstallation = state.newInstallationInitialValue;
        },

        setNewInformation: (state, {payload}) => {
            state.newInformation = payload;
        },

        setNewNotes: (state, {payload}) => {
            state.newNotes = payload;
        },

        setNewCommunicationHistory: (state, {payload}) => {
            state.newCommunicationHistory = payload;
        },

        resetNewCommunicationHistory: (state) => {
            state.newCommunicationHistory = state.newCommunicationHistoryInitialValue;
        },

        setSearchSuppliers: (state, {payload}) => {
            state.searchSuppliers = payload;
        },

        setSearchSupplierMovements: (state, {payload}) => {
            state.searchSupplierMovements = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setSelectedSupplierTemplate: (state, {payload}) => {
            state.selectedSupplierTemplate = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setNewSupplierMovements: (state, {payload}) => {
            state.newSupplierMovements = payload;
        },

        setEditSupplierMovements: (state, {payload}) => {
            state.editSupplierMovements = payload;
        },

        setSelectedSupplierMovementsTemplate: (state, {payload}) => {
            state.selectedSupplierMovementsTemplate = payload;
            state.loading = false;
            state.hasErrors = false;
        },

        setNewPriceList: (state, {payload}) => {
            state.newPriceList = payload;
        },

        setSuppliersSettings: (state, {payload}) => {
            state.suppliersSettings = payload;
            state.categories = payload.categories;
        },

        setSupplierMovementsSearchByBalance: (state, {payload}) => {
            state.supplierMovementsSearchByBalance = payload;
        },

        setSuppliersPayment: (state, {payload}) => {
            state.suppliersPayment = payload;
        },

        setNewSupplierPayment: (state, {payload}) => {
            state.newSupplierPayment = payload;
        },

        resetNewSupplierPayment: (state) => {
            state.newSupplierPayment = state.newSupplierPaymentInitialValue;
        },

        setAutoSupplierPaymentData: (state, {payload}) => {
            state.autoSupplierPaymentData = payload;
        },

        softResetNewSupplierPayment: (state, {payload}) => {
            state.newSupplierPayment = {...state.newSupplierPaymentInitialValue, ...payload};
        },

        setEditSupplierPayment: (state, {payload}) => {
            state.editSupplierPayment = payload;
        },

        // Supplier Isozygio Report
        initSupplierIsozygioReport: (state, {payload}) => {
            state.supplierIsozygioReportRequestData[payload.tabKey] = {...initSupplierIsozygioReportRequestData};
            state.supplierIsozygioReportResponseData[payload.tabKey] = {...initSupplierIsozygioReportResponseData};
            state.supplierIsozygioReportTotals[payload.tabKey] = {...initSupplierIsozygioReportTotals};
        },
        setSupplierIsozygioReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierIsozygioReportRequestData[tabKey] = action.payload;
        },
        setSupplierIsozygioReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierIsozygioReportResponseData[tabKey] = action.payload;
        },
        setSupplierIsozygioReportTotals: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierIsozygioReportTotals[tabKey] = action.payload;
        },

        setSupplierPaymentsSearch: (state, {payload}) => {
            state.searchSupplierPayments = payload;
        },
        setTotalItemsSPS: (state, {payload}) => {
            state.totalItemsSPS = payload;
        },
        setperPageSPS: (state, {payload}) => {
            state.perPageSPS = payload;
        },

        setSelectedStartDateFrom: (state, {payload}) => {
            state.selectedStartDateFrom = payload;
        },
        setSelectedStartDateTo: (state, {payload}) => {
            state.selectedStartDateTo = payload;
        },
        setSelectedDateBalance: (state, {payload}) => {
            state.selectedDateBalance = payload;
        },
        setSelectedZero: (state, {payload}) => {
            state.selectedZero = payload;
        },
        setSelectedInactive: (state, {payload}) => {
            state.selectedInactive = payload;
        },
        setSelectedZeroBalance: (state, {payload}) => {
            state.selectedZeroBalance = payload;
        },
        setSelectedInactiveBalance: (state, {payload}) => {
            state.selectedInactiveBalance = payload;
        },
        setSelectedFilterBy: (state, {payload}) => {
            state.selectedFilterBy = payload;
        },

        setTotalItemsSMSS: (state, {payload}) => {
            state.totalItemsSMSS = payload;
        },

        setperPageSMSS: (state, {payload}) => {
            state.perPageSMSS = payload;
        },
        setTotalItemsSSS: (state, {payload}) => {
            state.totalItemsSSS = payload;
        },

        setperPageSSS: (state, {payload}) => {
            state.perPageSSS = payload;
        },

        // Supplier Balance Report
        initSupplierBalanceReport: (state, {payload}) => {
            state.reportSupplierBalanceRequestData[payload.tabKey] = {...initSupplierBalanceReportRequestData};
            state.reportSupplierBalanceResponseData[payload.tabKey] = {...initSupplierBalanceReportResponseData};
        },
        setSupplierBalanceReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.reportSupplierBalanceRequestData[tabKey] = action.payload;
        },
        setSupplierBalanceReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.reportSupplierBalanceResponseData[tabKey] = action.payload;
        },

        // Supplier Movements Report
        initSupplierMovementsReport: (state, {payload}) => {
            state.supplierMovementsReportRequestData[payload.tabKey] = {...initSupplierMovementsReportRequestData};
            state.supplierMovementsReportResponseData[payload.tabKey] = {...initSupplierMovementsReportResponseData};
        },
        setSupplierMovementsReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierMovementsReportRequestData[tabKey] = action.payload;
        },
        setSupplierMovementsReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierMovementsReportResponseData[tabKey] = action.payload;
        },

        setSelectedSupplierCategory: (state, {payload}) => {
            state.selectedSupplierCategory = payload;
        }
    },
});

export const {
    setSupplierPaymentsTemplates,
    setSuppliers,
    setNewSupplier,
    resetNewSupplier,
    setNewSupplierModal,
    resetNewSupplierModal,
    setSearchSuppliers,
    setSearchSupplierMovements,
    setSelectedSupplierTemplate,
    setSelectedSupplierMovementsTemplate,
    setSuppliersSettings,
    setNewContactPoint,
    setEditContactPoint,
    setNewBankInfo,
    setEditBankInfo,
    resetNewBankInfo,
    resetEditBankInfo,
    setNewInstallations,
    resetNewInstallations,
    setNewSupplierMovements,
    setNewCommunicationHistory,
    resetNewCommunicationHistory,
    setEditSupplierMovements,
    setEditSupplier,
    setSuppliersPayment,
    setNewSupplierPayment,
    resetNewSupplierPayment,
    setAutoSupplierPaymentData,
    setNewSupplierStatus,
    setEditSupplierStatus,
    setSupplierPaymentsSearch,
    setTotalItemsSPS,
    setperPageSPS,
    setEditSupplierPayment,
    setSupplierMovementsSearchByBalance,
    setSupplierNewCategory,
    resetSupplierNewCategory,
    setTotalItemsSMSS,
    setperPageSMSS,
    setperPageSSS,
    setTotalItemsSSS,
    softResetNewSupplierPayment,

    // Supplier Balance Report
    initSupplierBalanceReport,
    setSupplierBalanceReportRequestData,
    setSupplierBalanceReportResponseData,

    // Supplier Isozygio Report
    initSupplierIsozygioReport,
    setSupplierIsozygioReportRequestData,
    setSupplierIsozygioReportResponseData,
    setSupplierIsozygioReportTotals,

    // Supplier Movements Report
    initSupplierMovementsReport,
    setSupplierMovementsReportRequestData,
    setSupplierMovementsReportResponseData,

    setSelectedSupplierCategory
} = SuppliersSlice.actions;
